export const CHECK_TYPES = ['sabores', 'promo_edge', 'pizza', 'edge', 'promo_geral'];